module.exports = __webpack_public_path__ + "static/media/yuantai.ff06917b.jpg";